import React from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { DialogRawProps } from './DialogRawProps';

export default (props: DialogRawProps) => {
    const { onClose, value: valueProp, open, options, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const [index, setIndex] = React.useState(0);
    const radioGroupRef = React.useRef<HTMLElement>(null);
  
    React.useEffect(() => {
      if (!open) {
        setValue(valueProp);
      }
    }, [valueProp, open]);
  
    const handleEntering = () => {
      if (radioGroupRef.current != null) {
        radioGroupRef.current.focus();
      }
    };
  
    const handleCancel = () => {
      onClose();
    };
  
    const handleOk = () => {
      onClose(value,index);
    };
  
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue((event.target as HTMLInputElement).value);
      setIndex(+(event.target as HTMLInputElement).id);
    };
  
    return (
      <Dialog
        maxWidth="xs"
        onEntering={handleEntering}
        aria-labelledby="confirmation-dialog-title"
        open={open}
        {...other}
      >
        <DialogTitle id="confirmation-dialog-title">Elija una Opción</DialogTitle>
        <DialogContent dividers>
          <RadioGroup
            ref={radioGroupRef}
            aria-label="dialog"
            name={value}
            value={value}
            onChange={handleChange}
          >
            {options.map((option) => (
              <FormControlLabel value={option.value} key={option.key} control={<Radio id={option.key} />} label={option.label} />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleOk} color="primary">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }